<template>
  <div
    class="container"
    :class="{'fx-mobile': isFxMobile}"
  >
    <router-link :to="link">
      <!-- <div class="texts">
        <h1>
          {{ title }}
        </h1>
        <p>{{ desc }}</p>
      </div> -->
      <div class="text_img">
        <img
          src="~@/assets/newSpark/logo_slogan_xs.svg"
          alt=""
        >
      </div>
      <div
        class="image"
        :style="{backgroundImage: `url(${image})`}"
      />
      <router-link :to="link">
        <!-- <button>了解更多</button> -->
        <div class="sparl_button">
          <div class="">
            <button>了解更多</button>
            <!-- <img
              src="~@/assets/newSpark/icon_arrow_tailed_right.svg"
              alt=""
            > -->
          </div>
        </div>
      </router-link>
    </router-link>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: ''
    },
    revision: {
      type: String,
      default: ''
    },
    desc: {
      type: String,
      default: ''
    },
    link: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      image: require('@/assets/newSpark/yinxiang1.png'),
      isFxMobile: true
    }
  },
  mounted: function () {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.container > a {
    width: 100%;
    height: 100%;
    text-decoration: none;
    margin: 32px;
}
a:link,
a:visited {
    font-weight: 300;
}
.container {
    width: 100%;
    max-width: 1920px;
    overflow: hidden;
    flex: 2;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
    opacity: 1;
    border-radius: 10px;
    /* background-image: radial-gradient(circle at 53% 22%, #43484f, #111114); */
    background: #282828;
    margin: 12px;
    max-width: calc(100% - 24px);
    /* padding: 32px; */
}
.fx-mobile {
    /* background-image: linear-gradient(333deg, #282828, #26394b); */
}
@media screen and (max-width: 768px) {
    .container {
        flex: 2 2 100%;
    }
}
.texts h1 {
    width: 100%;
    font-weight: 700;
    margin: 0;
}
.text_img {
    display: flex;
    align-items: center;
    justify-content: center;
}
.texts h1 span {
    font-weight: 300;
}
.texts h1 span.revision-mobile {
    font-size: 30px;
}
.texts p {
    display: block;
    width: 100%;
}
.image {
    min-height: 249px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
}
button {
    margin-top: 49px;
}
a {
    width: 120px;
}
h1 {
    font-size: 50px;
}
.sparl_button {
    display: flex;
    justify-content: center;
    .top_right_button {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 144px;
        height: 34px;
        background: rgba(255, 255, 255, 0.9);
        border-radius: 34px;
        color: #e02020;
        font-weight: bold;
        font-size: 12px;
        cursor: pointer;
        img {
            margin-left: 4px;
            width: 16px;
            height: 16px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/featured-spark.vue